import { NormalSelectOptions } from "@app/components/select/select.type";
import { BookOptionOption, SortOption } from "@app/types";

export enum BookOption {
  FREE = 1,
  VIP = 2,
  PURCHASE = 3,
}

export enum OptionName {
  FREE = "Miễn phí",
  VIP = "VIP",
  PURCHASE = "Mua lẻ",
}

export const BookOptionName = Object.freeze({
  [BookOption.FREE]: OptionName.FREE,
  [BookOption.VIP]: OptionName.VIP,
  [BookOption.PURCHASE]: OptionName.PURCHASE,
});

export const BookOptions: NormalSelectOptions = [
  { label: OptionName.FREE, value: BookOption.FREE.toString() },
  { label: OptionName.VIP, value: BookOption.VIP.toString() },
  { label: OptionName.PURCHASE, value: BookOption.PURCHASE.toString() },
];

export enum SortBy {
  ALL = 0,
  LATEST = 1,
  MOST_POPULAR = 2,
  OLDEST = 3,
}

export enum SortByName {
  ALL = "Tất cả",
  LATEST = "Mới nhất",
  MOST_POPULAR = "Phổ biến nhất",
  OLDEST = "Cũ nhất",
}

export const SortByOptions: NormalSelectOptions = [
  { label: SortByName.ALL, value: SortBy.ALL.toString() },
  { label: SortByName.LATEST, value: SortBy.LATEST.toString() },
  { label: SortByName.MOST_POPULAR, value: SortBy.MOST_POPULAR.toString() },
  { label: SortByName.OLDEST, value: SortBy.OLDEST.toString() },
];

export const TypeOfBookValue = Object.freeze({
  TOP_RECOMMENT: "topBookReComment",
  FREE: "bookFree",
  LATEST_RELEASE: "latestRelease",
});

export const TypeOfBookName = Object.freeze({
  [TypeOfBookValue.TOP_RECOMMENT]: "Top sách hay nên đọc",
  [TypeOfBookValue.FREE]: "Sách miễn phí",
  [TypeOfBookValue.LATEST_RELEASE]: "Mới xuất bản",
});

export enum PurchaseBookOption {
  RETAIL = 1,
  MEMBER = 2,
}

export enum SortOptionByName {
  POSTED_DATE = "Ngày đăng",
  A_TO_Z = "A - Z",
  POPULAR = "Phổ biến",
}

export const SortOptionOptions: NormalSelectOptions = [
  {
    label: SortOptionByName.POSTED_DATE,
    value: SortOption.POSTED_DATE.toString(),
  },
  {
    label: SortOptionByName.A_TO_Z,
    value: SortOption.A_TO_Z.toString(),
  },
  {
    label: SortOptionByName.POPULAR,
    value: SortOption.POPULAR.toString(),
  },
];

export const BookOptionOptionByName = {
  [BookOptionOption.FREE]: "Sách Free",
  [BookOptionOption.VIP]: "Sách VIP",
};

export const MAX_LENGTH_BOOK_NOTE = 100;
